/* @ngInject */
const myCommande = () => {
  return {
    restrict: 'E',
    scope: {
      myCommande: '=',
    },
    template: require('./myCommande.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myCommande



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/directives/display/myCommande.js